import React, { useEffect, useState } from 'react'
import { EditPage } from '@equipedigitalfloripa/ed-cms/components'
// import { EditPage } from '../components/EditPage'
import * as filiadosApi from '../api/filiados'

const EditConvenio = ({ edit }) => {


  const selectedData = [
    {
      name: '_id',
      type: 'hidden',
      title: 'Id'
    },
    {
      name: 'name',
      type: 'text',
      title: "Nome",
    },
    {
      name: 'email',
      type: 'text',
      title: "Email",
    },
    {
      name: 'cpf',
      type: 'text',
      title: "CPF",
    },
    {
      name: 'nascimento',
      type: 'text',
      title: "Nascimento",
    },
    {
      name: 'matricula',
      type: 'text',
      title: "Matrícula",
    },
    {
      name: 'UO',
      type: 'text',
      title: "Unidade Organizacional",
    },
    {
      name: 'categoria',
      type: 'text',
      title: "Categoria",
    },
    {
      name: 'celular',
      type: 'text',
      title: "Celular",
    },
    {
      name: 'telefone',
      type: 'text',
      title: "Telefone",
    },
    {
      name: 'cep',
      type: 'text',
      title: "CEP",
    },
    {
      name: 'endereco',
      type: 'text',
      title: "Endereço",
    },
    {
      name: 'numero',
      type: 'text',
      title: "Número",
    },
    {
      name: 'complemento',
      type: 'text',
      title: "Complemento",
    },
    {
      name: 'bairro',
      type: 'text',
      title: "Bairro",
    },
    {
      name: 'cidade',
      type: 'text',
      title: "Cidade",
    },
    {
      name: 'estado',
      type: 'text',
      title: "Estado",
    },
  ]
  return (
    <EditPage
      title={edit ? "Editar filiado Solicitação" : "Adicionar Serviço"}
      subtitle={edit ? "Alterando informações Solicitação" : "Adicionando informações Solicitação"}
      selectedData={selectedData} 
      addFunction={filiadosApi.addItem}
      fetchFunction={filiadosApi.fetchItem}
      // editFunction={filiadosApi.editItem}
      edit={edit}
      url='filiados-solicitacoes'
    />
  )
}

export default EditConvenio
